export default __webpack_public_path__ + "static/media/Backgrounds-1.86c0b4ed.jpg";